export default "/images/borderlands-lg.png";